<template>
  <b-row>
    <b-col cols="12">
      <campaign-payments-table :key="$route.fullPath" />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import CampaignPaymentsTable from './CampaignPaymentsTable.vue'

export default {
  components: {
    BRow,
    BCol,
    CampaignPaymentsTable,
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
